import React, {Component} from 'react';
import { ACCESS_TOKEN,SESSION_USER,API_BASE_URL } from '../constants';

import NavPopUp from './NavPopUp';


class Header extends Component {

    constructor(props) {
        super(props);   
        this.handleMenuClick = this.handleMenuClick.bind(this);   
    }

    handleMenuClick() {
        this.props.onLogout();
    }


    render(){
       let user = JSON.parse(localStorage.getItem(SESSION_USER));
      
       var companyImageUrl="../static/assets/images/people.png";
       var peopleImageUrl="../static/assets/images/people.png";

       var emailAddress='';
       var appUserName='';
       var companyName='';       
       
       if(user){

        if(user.companyImageUrl){
            companyImageUrl=API_BASE_URL+user.companyImageUrl;
        }
         
        if(user.peopleImageUrl){
             peopleImageUrl=API_BASE_URL+user.peopleImageUrl;
        }
       
        if(user.email){
           emailAddress=user.email;
        }
        if(user.company){
             companyName=user.company;
        }
        if(user.name){
              appUserName=user.name;
        }

            let roleName='';
             if(user && user.roles){
                roleName=user.roles[0]
             }
         
       }
      
       


    return (<header className="topbar">
            <nav className="navbar top-navbar navbar-expand-md navbar-light">
               
                <div className="navbar-header">
                    <a className="navbar-brand" href="/schedule">
                     
                        <b>
                         
                            <img src="/static/assets/images/field-tech-logo.png" width="150" alt="homepage" className="dark-logo" />
                          
                            <img src="/static/assets/images/field-tech-logo.png" width="150"  alt="homepage" className="light-logo" />
                        </b>
                      
                         </a>
                </div>
              
                <div className="navbar-collapse">
                   
                    <ul className="navbar-nav mr-auto mt-md-0">
                      
                        <li className="nav-item"> <a className="nav-link nav-toggler hidden-md-up text-muted waves-effect waves-dark" ><i className="mdi mdi-menu"></i></a> </li>
                        
                    </ul>
                  

         { 
            localStorage.getItem(ACCESS_TOKEN) ? (
                      <ul className="navbar-nav my-lg-0">
                         <li className="nav-item"> <a className="nav-link nav-toggler hidden-md-up text-muted waves-effect waves-dark" ><i className="mdi mdi-menu"></i></a> </li>
                        
                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle text-muted waves-effect waves-dark" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img src={companyImageUrl} alt="user" style={{backgroundColor: 'white'}}  className="profile-pic" /></a>
                            <div className="dropdown-menu dropdown-menu-right scale-up">
                                <ul className="dropdown-user">
                                    <li>
                                        <div className="dw-user-box">
                                            <div className="u-img"><img src={peopleImageUrl} alt="user"/></div>
                                            <div className="u-text">
                                                <h4>{appUserName}</h4>
                                                <p className="text-muted">{emailAddress}</p><a className="btn btn-rounded btn-danger btn-sm">{companyName}</a></div>
                                        </div>
                                    </li>
                                    <li role="separator" className="divider"></li>
                                   

                                      <NavPopUp/>

                                    <li role="separator" className="divider"></li>
                                    <li onClick={this.handleMenuClick} ><a href="/"><i className="fa fa-power-off"></i> Logout</a></li>
                                </ul>
                            </div>
                        </li>
                        
                    </ul>
            ):null
         }   

                    

                </div>
            </nav>       
    </header>);
  } 
}
export default Header;
